export default class ContactGenerator {
  constructor(config) {
    this.$container = config.$container;
    this.csvUrl = undefined;
    this.count = undefined;
    this.contactFileName = undefined;
    this.exportId = config.exportId;
  }

  init() {
    this._initListeners();
    return this;
  }

  _initListeners() {
    this.$container.hide();
    this.pollEndpoint();
  }

  pollEndpoint() {
    if (this.csvUrl) {
      if (this.$container.is(":visible")) return;

      $('#loading-message').hide();
      $('#contact-length').html(this.count);
      this.$container.show();

      return;
    }

    $.get(`/admin/campaigns/export_status?export_id=${this.exportId}`, (data) => {
      this.csvUrl = data.url;
      this.count = data.count;
      this.fileName = data.file_name;
      setTimeout(this.pollEndpoint.bind(this), 2500);
    });
  }
}
